import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/img/icon/plane-fill-darkblue.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "md:flex items-center justify-between p-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-bold" }, "Data Kru Belum Setor", -1)
const _hoisted_4 = { class: "w-full md:w-1/3" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex items-center gap-3" }
const _hoisted_7 = { class: "text-base font-bold" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center background-custom-light-blue-1 border-custom-dark-blue-1 rounded px-12px py-4px text-xs custom-label"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-3 w-4",
  alt: "edit"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "color-grey-5" }, /*#__PURE__*/_toDisplayString('Bandara'), -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "overflow-x-auto"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Tidak ada data ditemukan. ", -1)
const _hoisted_14 = { class: "text-left break-words text-grey font-bold text-sm" }
const _hoisted_15 = { class: "text-left break-all text-grey font-normal text-sm" }
const _hoisted_16 = { class: "text-left break-words text-grey font-normal text-sm" }
const _hoisted_17 = { class: "text-left break-words text-primary font-bold text-base" }
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIconRight = _resolveComponent("InputIconRight")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "invalid-condectur-dashboard card-no-shadow" }, {
    content: _withCtx(() => [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_InputIconRight, {
                  class: "input-search-header-custom",
                  placeholder: "Cari Kru",
                  modelValue: _ctx.inputSearch,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputSearch) = $event)),
                  canClick: true,
                  icon: _ctx.icon.svg.searchEva,
                  onSubmitInput: _ctx.onSearch,
                  onKeyup: _withKeys(_ctx.onSearch, ["enter"]),
                  disabled: false
                }, null, 8, ["modelValue", "icon", "onSubmitInput", "onKeyup"])
              ])
            ]),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource, (data) => {
                return (_openBlock(), _createElementBlock("div", { key: data }, [
                  _createElementVNode("div", {
                    class: "py-2 px-2 mb-3 flex gap-2 items-center background-grey-2 rounded-lg cursor-pointer",
                    onClick: ($event: any) => (_ctx.selectInvalidCondectur(data.CrewId))
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["mr-3", _ctx.selectedConductor === data.CrewId ? 'pi pi-angle-down' : 'pi pi-angle-right'])
                      }, null, 2)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(data.CrewName), 1),
                      (data.CrewRole.toLowerCase() === 'driver')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_5),
                  (_ctx.selectedConductor === data.CrewId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_DataTable, {
                          value: data.TransactionPps,
                          rows: 5,
                          class: "invalid-conductor-table-detail w-full"
                        }, {
                          empty: _withCtx(() => [
                            _hoisted_13
                          ]),
                          loading: _withCtx(() => [
                            _createVNode(_component_ProgressSpinner, { style: {"width":"70px","height":"70px"} })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_Column, {
                              field: "VehicleRegNumber",
                              header: "NOPOL",
                              style: {"min-width":"110px"},
                              class: "text-left break-words text-grey font-normal text-sm w-2/12"
                            }, {
                              body: _withCtx(({ data, field }) => [
                                _createElementVNode("p", _hoisted_14, _toDisplayString(data[field]), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_Column, {
                              field: "TrxId",
                              header: "KODE STAT",
                              style: {"min-width":"110px"},
                              class: "text-left break-words text-grey font-normal text-sm w-3/12"
                            }, {
                              body: _withCtx(({ data, field }) => [
                                _createElementVNode("p", _hoisted_15, _toDisplayString(data[field]), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_Column, {
                              field: "CreatedAt",
                              header: "TANGGAL PERJALANAN",
                              style: {"min-width":"110px"},
                              class: "text-left break-words text-grey font-normal text-sm w-2/12"
                            }, {
                              body: _withCtx(({ data, field }) => [
                                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.moment(data[field]).format('DD MMMM YYYY')), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_Column, {
                              field: "TotalTicketAmount",
                              header: "NOMINAL PENDAPATAN",
                              style: {"min-width":"110px"},
                              class: "text-left break-words text-grey font-normal text-smw-3/12"
                            }, {
                              body: _withCtx(({ data, field }) => [
                                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.currencyNumberFormat(data[field])), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_Column, {
                              header: "AKSI",
                              style: {"min-width":"110px"},
                              class: "text-left break-words text-grey font-normal text-sm w-2/12"
                            }, {
                              body: _withCtx(({ data }) => [
                                _createElementVNode("div", {
                                  class: "py-1 px-3 background-grey-2 w-fit rounded-lg text-primary text-sm cursor-pointer",
                                  onClick: ($event: any) => (_ctx.toApprovePp(data.Id))
                                }, "Cek Setoran", 8, _hoisted_18)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["value"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (_ctx.filters.totalRecords > 0)
                ? (_openBlock(), _createBlock(_component_Paginator, {
                    key: 0,
                    rows: _ctx.filters.pageSize,
                    totalRecords: _ctx.filters.totalRecords,
                    onOnPage: _ctx.onChangePage,
                    rowsPerPageOptions: _ctx.filters.rowPerPageOptions
                  }, null, 8, ["rows", "totalRecords", "onOnPage", "rowsPerPageOptions"]))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_EmptyState, { text: "Oops, data yang kamu cari tidak ditemukan" }, null, 512), [
                [_vShow, _ctx.filters.totalRecords === 0]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}